import React, { useEffect, useRef, useState } from 'react';

const AnimateOnScroll = ({ 
  children, 
  animation = 'fade-up', 
  delay = 0,
  threshold = 0.1,
  className = ''
}) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold }
    );

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold]);

  const animationClasses = {
    'fade-up': 'animate-fade-up',
    'fade-left': 'animate-fade-left',
    'fade-right': 'animate-fade-right',
    'scale': 'animate-scale',
    'fade': 'animate-on-scroll'
  };

  const delayClasses = {
    0: '',
    1: 'stagger-1',
    2: 'stagger-2',
    3: 'stagger-3',
    4: 'stagger-4',
    5: 'stagger-5',
    6: 'stagger-6'
  };

  return (
    <div
      ref={ref}
      className={`${animationClasses[animation] || 'animate-fade-up'} ${delayClasses[delay] || ''} ${isVisible ? 'animate-visible' : ''} ${className}`}
    >
      {children}
    </div>
  );
};

export default AnimateOnScroll;
